module.exports = __webpack_public_path__ + "assets/thumbs_up.2953fff9f2199828d6348097d70dd07380478d2fae984ce8fa75818d265e5b6e.png";